import dayjs from "dayjs";

/** dayjs .day(): 0=Sunday … 6=Saturday */
export const HEBREW_WEEKDAY_NAMES = [
  "ראשון",
  "שני",
  "שלישי",
  "רביעי",
  "חמישי",
  "שישי",
  "שבת",
];

function parseToDayjs(raw) {
  if (raw == null || raw === "") return null;
  const s = String(raw).trim().split(/\s+/)[0];
  if (!s) return null;
  if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(s)) {
    const [d, m, y] = s.split("/");
    const iso = `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
    const x = dayjs(iso);
    return x.isValid() ? x : null;
  }
  if (/^\d{8}$/.test(s)) {
    const x = dayjs(
      `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`
    );
    return x.isValid() ? x : null;
  }
  const x = dayjs(s);
  return x.isValid() ? x : null;
}

/**
 * מספר לילות לפי תאריכי צ'ק־אין/אאוט (כמו formatDiscoveryStayDates).
 * @param {string|undefined|null} depRaw
 * @param {string|undefined|null} retRaw
 * @returns {number|null}
 */
export function resolveDiscoveryNights(depRaw, retRaw) {
  const dep = parseToDayjs(depRaw);
  const ret = parseToDayjs(retRaw);
  if (!dep || !ret) return null;
  const nights = Math.max(0, ret.diff(dep, "day"));
  return nights > 0 ? nights : null;
}

/**
 * טווח ימים בשבוע לפי תאריכי צ'ק־אין/אאוט — למשל "ראשון-חמישי".
 * @param {string|undefined|null} depRaw
 * @param {string|undefined|null} retRaw
 * @returns {string|null}
 */
export function formatDiscoveryStayWeekdaysRange(depRaw, retRaw) {
  const dep = parseToDayjs(depRaw);
  const ret = parseToDayjs(retRaw);
  if (!dep || !ret) return null;
  const depName = HEBREW_WEEKDAY_NAMES[dep.day()];
  const retName = HEBREW_WEEKDAY_NAMES[ret.day()];
  if (!depName || !retName) return null;
  if (depName === retName) return depName;
  return `${depName}-${retName}`;
}

/**
 * תצוגת טווח תאריכים (12.05.2026 - 16.05.2026) ומשך שהייה.
 * @param {string|undefined|null} depRaw
 * @param {string|undefined|null} retRaw
 * @returns {{ rangeLabel: string, stayLabel: string|null, weekdaysLabel: string|null }}
 */
export function formatDiscoveryStayDates(depRaw, retRaw) {
  const dep = parseToDayjs(depRaw);
  const ret = parseToDayjs(retRaw);
  if (!dep || !ret) {
    return { rangeLabel: "תאריכים יוצגו בחיפוש", stayLabel: null, weekdaysLabel: null };
  }
  const rangeLabel = `${dep.format("DD.MM.YYYY")} - ${ret.format("DD.MM.YYYY")}`;
  const nights = Math.max(0, ret.diff(dep, "day"));
  const days = nights + 1;
  const stayLabel =
    nights > 0 ? `${nights} לילות / ${days} ימים` : null;
  const weekdaysLabel = formatDiscoveryStayWeekdaysRange(depRaw, retRaw);
  return { rangeLabel, stayLabel, weekdaysLabel };
}
